var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurePayment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 553.558,
    height: 414.164,
    viewBox: "0 0 553.558 414.164",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "secure-payment",
    transform: "translate(0 0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 -0.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    "data-name": "Rectangle 307",
    width: 43.711,
    height: 0.334,
    transform: "translate(376.442 405.045)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    "data-name": "Rectangle 308",
    width: 54.301,
    height: 0.334,
    transform: "translate(470.018 405.201)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    "data-name": "Rectangle 309",
    width: 25.328,
    height: 0.334,
    transform: "translate(413.242 413.829)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    "data-name": "Rectangle 310",
    width: 68.192,
    height: 0.334,
    transform: "translate(172.023 411.332)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    "data-name": "Rectangle 311",
    width: 45.383,
    height: 0.334,
    transform: "translate(114.89 411.332)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    "data-name": "Rectangle 312",
    width: 61.815,
    height: 0.334,
    transform: "translate(25.908 405.758)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1165",
    "data-name": "Path 1165",
    d: "M74.007,291.738H26.06V77.464L74.007,61.79Z",
    transform: "translate(2.991 7.112)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M109.918,286.452H61.96V123.5l47.958-15.663Z",
    transform: "translate(7.112 12.398)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1167",
    "data-name": "Path 1167",
    d: "M101.029,122.2H89.58V83.316l11.449-3.746Z",
    transform: "translate(10.283 9.153)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    "data-name": "Rectangle 313",
    width: 53.967,
    height: 127.387,
    transform: "translate(180.027 171.474)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M344.92,282.361h95.905v-126.7L344.92,143.48Z",
    transform: "translate(39.593 16.489)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M14.527,172.56H38.585V279.022H2.51V184.577A12.017,12.017,0,0,1,14.527,172.56Z",
    transform: "translate(0.288 19.827)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    "data-name": "Rectangle 314",
    width: 47.914,
    height: 102.728,
    transform: "translate(124.199 196.122)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M257.814,191.829,209.9,175.91V278.638h47.914Z",
    transform: "translate(24.094 20.212)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1171",
    "data-name": "Path 1171",
    d: "M274.1,191.829,226.18,175.91V278.638H274.1Z",
    transform: "translate(25.963 20.212)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1172",
    "data-name": "Path 1172",
    d: "M269.17,177.2l47.914-15.919V280.317H269.17Z",
    transform: "translate(30.898 18.532)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1173",
    "data-name": "Path 1173",
    d: "M79.53,308.835c14.269-76.441,51.8-112.315,83.8-130.575C132.706,207.222,111.881,307.431,79.53,308.835Z",
    transform: "translate(9.129 20.481)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1174",
    "data-name": "Path 1174",
    d: "M57.434,299.241C46.933,241.651,21.493,219.1,0,209.5,20.746,227.66,35.907,302.9,57.434,299.241Z",
    transform: "translate(0 24.068)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1175",
    "data-name": "Path 1175",
    d: "M74.651,317.81C70.593,234.937,39.045,198.528,10.64,181.07,36.4,210.422,43.76,318.914,74.651,317.81Z",
    transform: "translate(1.221 20.804)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1176",
    "data-name": "Path 1176",
    d: "M68.06,311.967c6.588-83.286,41.816-122.259,73.13-142.047C112.44,201.379,101.582,310.562,68.06,311.967Z",
    transform: "translate(7.813 19.524)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1177",
    "data-name": "Path 1177",
    d: "M76.487,326.306C87.066,240.768,63.7,189.187,40,158.24,59.152,199.967,47.224,312.928,76.487,326.306Z",
    transform: "translate(4.592 18.183)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1178",
    "data-name": "Path 1178",
    d: "M102.18,292.161c26.7-49.887,60.121-61.726,85.839-62.941C160.818,238.673,124.375,303.264,102.18,292.161Z",
    transform: "translate(11.729 26.331)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1179",
    "data-name": "Path 1179",
    d: "M97.26,296.8c16.811-56.475,48.6-80.454,74.691-91.625C146.1,224.522,122.421,298.388,97.26,296.8Z",
    transform: "translate(11.164 23.572)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1180",
    "data-name": "Path 1180",
    d: "M71.869,327.438C100.586,238.868,87.621,184.254,70.007,151,80.732,195.246,44.9,312.266,71.869,327.438Z",
    transform: "translate(7.069 17.352)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1181",
    "data-name": "Path 1181",
    d: "M27.1,280.69v55.74c0,14.247,25.707,25.9,57.122,25.9h0c31.426,0,57.122-11.65,57.122-25.9V280.69Z",
    transform: "translate(3.111 32.239)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M426.678,322.976c-3.166-52.574-25.8-77.244-46.108-89.8C399.042,253.1,404.65,322.007,426.678,322.976Z",
    transform: "translate(43.686 26.786)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M441.58,316.408c12.174-39.631,31.549-55.138,47.089-61.748C472.895,267.157,456.005,318.894,441.58,316.408Z",
    transform: "translate(50.689 29.251)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1184",
    "data-name": "Path 1184",
    d: "M429.07,329.154c9.933-57,34.692-82.026,55.65-94.044C464.543,255.3,450.173,329.9,429.07,329.154Z",
    transform: "translate(49.253 27.007)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1185",
    "data-name": "Path 1185",
    d: "M433.514,325.129c2.687-57.278-18.082-84.077-37.814-97.689C412.678,249.078,410.672,324.159,433.514,325.129Z",
    transform: "translate(45.422 26.127)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1186",
    "data-name": "Path 1186",
    d: "M425.41,335c.145-58.827,20.612-94.278,39.508-115.593C448.207,248.116,446.613,325.772,425.41,335Z",
    transform: "translate(48.833 25.205)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1187",
    "data-name": "Path 1187",
    d: "M412.753,311.507c-13.979-34.3-35.841-42.451-53.343-43.287C377.213,274.719,396.588,319.144,412.753,311.507Z",
    transform: "translate(41.257 30.808)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1188",
    "data-name": "Path 1188",
    d: "M414.936,314.7c-6.689-38.839-26.331-55.327-43.276-63.008C387.735,264.989,397.568,315.79,414.936,314.7Z",
    transform: "translate(42.663 28.911)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1189",
    "data-name": "Path 1189",
    d: "M427.185,335.761c-12.017-60.912,1.583-98.458,16.51-121.311C432.525,244.861,446.961,325.327,427.185,335.761Z",
    transform: "translate(48.507 24.636)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1190",
    "data-name": "Path 1190",
    d: "M464.583,303.66v38.282c0,9.777-17.636,17.77-39.2,17.77h0c-21.56,0-39.207-7.993-39.207-17.77V303.66Z",
    transform: "translate(44.33 34.876)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    "data-name": "Rectangle 315",
    width: 117.465,
    height: 180.641,
    rx: 7.54,
    transform: "translate(364.854 162.242) rotate(-85.83)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1191",
    "data-name": "Path 1191",
    d: "M473.5,76.291a12.474,12.474,0,1,1-2.993-9.083,12.463,12.463,0,0,1,2.993,9.083Z",
    transform: "translate(51.496 7.237)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1192",
    "data-name": "Path 1192",
    d: "M474.573,89.44h-.959A13.032,13.032,0,1,1,487.56,77.4h0A13.054,13.054,0,0,1,474.573,89.44Zm0-24.938a11.906,11.906,0,1,0,11.884,12.776h0a11.928,11.928,0,0,0-11.025-12.742q-.435-.033-.87-.033Z",
    transform: "translate(52.979 7.298)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1193",
    "data-name": "Path 1193",
    d: "M344.736,108.722l-.725,10.033-1.037-.078.669-9.086-2.363-.167.067-.914Z",
    transform: "translate(39.176 12.475)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1194",
    "data-name": "Path 1194",
    d: "M353.729,118.491l-.067.914-7.012-.513v-.725l4.459-3.768c1.215-1.037,1.472-1.694,1.527-2.375.078-1.115-.68-1.929-2.23-2.04a3.344,3.344,0,0,0-2.809.914l-.68-.68a4.459,4.459,0,0,1,3.645-1.115c2.029.145,3.233,1.271,3.11,2.943-.067.948-.424,1.784-1.862,3l-3.645,3.1Z",
    transform: "translate(39.792 12.538)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1195",
    "data-name": "Path 1195",
    d: "M363.463,117.454l-2.007-.145-.19,2.631-1.026-.078.19-2.631-5.641-.412v-.736l5.775-6.243,1.115.078L356.105,116l4.348.312.167-2.308.992.067-.167,2.319,2.007.145Z",
    transform: "translate(40.726 12.628)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M377.2,118.454l-2-.145-.19,2.631-1.026-.078.19-2.631-5.641-.412v-.736l5.775-6.243,1.115.078L369.855,117l4.337.323.178-2.319.992.067-.167,2.319,2,.145Z",
    transform: "translate(42.305 12.742)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M384.936,118.771c-.123,1.706-1.4,2.943-3.857,2.765a5.139,5.139,0,0,1-3.489-1.55l.557-.78a4.325,4.325,0,0,0,2.988,1.382c1.706.123,2.664-.635,2.754-1.851s-.647-2.14-3.188-2.33l-2.129-.156.881-4.972,5.462.4-.067.914-4.571-.334-.569,3.155,1.282.1C384.011,115.683,385.059,116.954,384.936,118.771Z",
    transform: "translate(43.344 12.793)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M393.812,119.325a3.121,3.121,0,0,1-3.645,2.82c-2.653-.19-3.957-2.14-3.735-5.3.245-3.344,2.23-5.039,4.95-4.838a4.571,4.571,0,0,1,2.33.713l-.468.791a3.456,3.456,0,0,0-1.906-.6c-2.163-.167-3.645,1.115-3.846,3.835v.825a3.222,3.222,0,0,1,3.188-1.494,3.032,3.032,0,0,1,3.133,3.244Zm-1.014,0c.089-1.315-.825-2.23-2.363-2.341a2.319,2.319,0,0,0-2.731,2c-.078,1.115.758,2.23,2.486,2.341a2.23,2.23,0,0,0,2.609-2.04Z",
    transform: "translate(44.356 12.875)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M406.066,120.349c-.112,1.672-1.427,2.876-3.835,2.7a5.173,5.173,0,0,1-3.512-1.55l.557-.78A4.359,4.359,0,0,0,402.3,122.1c1.65.123,2.631-.58,2.72-1.817s-.7-2.051-2.564-2.23l-.714-.056.056-.758,3.032-3.266-5.117-.368.067-.914,6.432.457-.056.736-3.088,3.344C405.2,117.55,406.189,118.754,406.066,120.349Z",
    transform: "translate(45.769 12.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1200",
    "data-name": "Path 1200",
    d: "M415.082,120.875a3.121,3.121,0,0,1-3.645,2.82c-2.653-.19-3.957-2.14-3.735-5.3.256-3.4,2.23-5.039,4.95-4.838a4.571,4.571,0,0,1,2.33.713l-.468.792a3.556,3.556,0,0,0-1.906-.613c-2.163-.156-3.645,1.115-3.846,3.846v.814a3.2,3.2,0,0,1,3.177-1.483,3.032,3.032,0,0,1,3.144,3.244Zm-1.014,0c.089-1.315-.814-2.23-2.363-2.341a2.319,2.319,0,0,0-2.731,2c-.078,1.115.758,2.23,2.486,2.33a2.23,2.23,0,0,0,2.609-2.029Z",
    transform: "translate(46.797 13.053)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1201",
    "data-name": "Path 1201",
    d: "M423.771,114.49v.725l-4.861,8.918-1.115-.078,4.771-8.785-5.139-.379-.134,1.873-1.014-.067.2-2.787Z",
    transform: "translate(47.785 13.095)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1202",
    "data-name": "Path 1202",
    d: "M436.621,115.421v.725l-4.861,8.918-1.115-.089,4.771-8.785-5.139-.368-.134,1.873-1.014-.078.2-2.787Z",
    transform: "translate(49.26 13.2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1203",
    "data-name": "Path 1203",
    d: "M445.008,123.263c-.123,1.761-1.706,2.754-4.091,2.586s-3.779-1.382-3.645-3.155a2.486,2.486,0,0,1,2.107-2.319,2.23,2.23,0,0,1-1.416-2.319c.123-1.628,1.583-2.531,3.69-2.386s3.456,1.271,3.344,2.9a2.23,2.23,0,0,1-1.75,2.085,2.531,2.531,0,0,1,1.761,2.609Zm-1.059-.1c.089-1.226-.9-2.074-2.676-2.23s-2.876.569-2.965,1.795.9,2.1,2.675,2.23,2.876-.546,2.965-1.795Zm-2.62-3.021c1.561.123,2.542-.513,2.62-1.605s-.858-1.884-2.363-1.984-2.519.5-2.6,1.616.78,1.862,2.341,1.973Z",
    transform: "translate(50.193 13.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1204",
    "data-name": "Path 1204",
    d: "M453.827,121.6c-.245,3.344-2.23,5.028-4.939,4.838a4.615,4.615,0,0,1-2.341-.725l.513-.825a3.556,3.556,0,0,0,1.906.613c2.163.156,3.645-1.115,3.846-3.846v-.814a3.211,3.211,0,0,1-3.177,1.494,3.032,3.032,0,0,1-3.155-3.244,3.133,3.133,0,0,1,3.634-2.832C452.757,116.5,454.061,118.449,453.827,121.6Zm-1.26-2.1c.078-1.115-.758-2.23-2.5-2.33a2.23,2.23,0,0,0-2.6,2c-.089,1.315.814,2.23,2.363,2.341a2.33,2.33,0,0,0,2.731-2.007Z",
    transform: "translate(51.251 13.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1205",
    "data-name": "Path 1205",
    d: "M462.845,117.322l-.725,10.033-1.026-.078.658-9.086-2.352-.167.067-.914Z",
    transform: "translate(52.735 13.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1206",
    "data-name": "Path 1206",
    d: "M471.849,127.091l-.067.914-7.012-.513.056-.725L469.285,123c1.2-1.026,1.472-1.683,1.516-2.374.089-1.115-.68-1.929-2.23-2.04a3.411,3.411,0,0,0-2.809.914l-.68-.68a4.459,4.459,0,0,1,3.645-1.115c2.029.145,3.244,1.271,3.121,2.943-.067.959-.435,1.795-1.873,3.01l-3.645,3.088Z",
    transform: "translate(53.351 13.525)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1207",
    "data-name": "Path 1207",
    d: "M480.056,125.79c-.123,1.672-1.427,2.876-3.846,2.7a5.162,5.162,0,0,1-3.5-1.55l.557-.78a4.336,4.336,0,0,0,3.01,1.382c1.661.123,2.631-.58,2.72-1.817s-.691-2.051-2.553-2.23l-.714-.056.056-.758,3.021-3.266-5.117-.379.067-.914,6.432.468-.056.736-3.088,3.344C479.187,122.936,480.168,124.14,480.056,125.79Z",
    transform: "translate(54.263 13.578)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    "data-name": "Rectangle 316",
    width: 4.359,
    height: 80.321,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, 456.38, 148.346)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    "data-name": "Rectangle 317",
    width: 4.359,
    height: 41.192,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, 494.749, 159.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(378.374 87.05)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    "data-name": "Rectangle 318",
    width: 33.7,
    height: 25.172,
    rx: 4.96,
    transform: "translate(1.831 0) rotate(4.17)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1208",
    "data-name": "Path 1208",
    d: "M339.88,95.42l.112-1.616L357.3,95.041a3.627,3.627,0,1,0,.524-7.235l-17.3-1.271.112-1.605,17.313,1.26a5.251,5.251,0,1,1-.769,10.468Z",
    transform: "translate(39.015 9.768)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_319",
    "data-name": "Rectangle 319",
    width: 1.616,
    height: 11.906,
    transform: "translate(400.953 102.339) rotate(-85.78)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_320",
    "data-name": "Rectangle 320",
    width: 86.675,
    height: 7.436,
    transform: "translate(385.687 66.659) rotate(4.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1209",
    "data-name": "Path 1209",
    d: "M283.581,393.664l-124.321-.58a27.067,27.067,0,0,1-26.989-27.212l1.315-311.684a27.078,27.078,0,0,1,27.2-26.978l124.333.58a27.089,27.089,0,0,1,26.956,27.2l-1.327,311.684A27.078,27.078,0,0,1,283.581,393.664Z",
    transform: "translate(15.183 3.142)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1210",
    "data-name": "Path 1210",
    d: "M284.091,37.455l-24.113-.111A5.986,5.986,0,0,0,254.1,43.43v4.381a5.986,5.986,0,0,1-5.931,6.087l-46.955-.167a6,6,0,0,1-5.819-6.154V43.163a5.986,5.986,0,0,0-5.808-6.154h-8.484l-21.092-.089A18.951,18.951,0,0,0,140.952,55.8L139.67,360.031a18.951,18.951,0,0,0,18.885,19.041l124.076.58a18.951,18.951,0,0,0,19.052-18.918L302.965,56.5A18.951,18.951,0,0,0,284.091,37.455Z",
    transform: "translate(16.033 4.257)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1211",
    "data-name": "Path 1211",
    d: "M206.762,318.43a2.6,2.6,0,1,1-2.553-2.23A2.4,2.4,0,0,1,206.762,318.43Z",
    transform: "translate(23.141 36.315)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1212",
    "data-name": "Path 1212",
    d: "M213.87,318.46a2.586,2.586,0,1,1-2.553-2.23,2.4,2.4,0,0,1,2.553,2.23Z",
    transform: "translate(23.959 36.319)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1213",
    "data-name": "Path 1213",
    d: "M220.987,318.5a2.586,2.586,0,1,1-2.558-2.208A2.586,2.586,0,0,1,220.987,318.5Z",
    transform: "translate(24.78 36.326)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1214",
    "data-name": "Path 1214",
    d: "M237.228,218.73v12.107h-2.809v-9.855H232v-2.23Z",
    transform: "translate(26.631 25.127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1215",
    "data-name": "Path 1215",
    d: "M241.087,230.319a4.86,4.86,0,0,1-1.839-2.152,8.807,8.807,0,0,1,0-6.689,4.944,4.944,0,0,1,9.041,0,8.807,8.807,0,0,1,0,6.689,5.005,5.005,0,0,1-1.839,2.152,5.184,5.184,0,0,1-5.362,0Zm4.459-2.575a7.135,7.135,0,0,0,0-5.886,2.051,2.051,0,0,0-3.456,0,7.135,7.135,0,0,0,0,5.886,2.051,2.051,0,0,0,3.456,0Z",
    transform: "translate(27.388 25.11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1216",
    "data-name": "Path 1216",
    d: "M254.659,219.56a2.53,2.53,0,0,1,.58,1.806,3.044,3.044,0,0,1-.312,1.438,2.084,2.084,0,0,1-.881.9,2.664,2.664,0,0,1-1.315.312,2.821,2.821,0,0,1-.758-.089,2.228,2.228,0,0,1-.613-.245l.424-.836a1.672,1.672,0,0,0,.925.245,1.349,1.349,0,0,0,.992-.368,1.561,1.561,0,0,0,.39-1.115,1.627,1.627,0,0,1-1.226.446,1.973,1.973,0,0,1-.858-.19,1.617,1.617,0,0,1-.613-.546,1.438,1.438,0,0,1-.223-.8,1.55,1.55,0,0,1,.925-1.438,2.141,2.141,0,0,1,.936-.2A2.107,2.107,0,0,1,254.659,219.56Zm-.925,1.483a.7.7,0,0,0,.234-.535.658.658,0,0,0-.234-.524,1.115,1.115,0,0,0-1.226,0,.758.758,0,0,0,0,1.115.9.9,0,0,0,.613.2.948.948,0,0,0,.613-.256Z",
    transform: "translate(28.832 25.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1217",
    "data-name": "Path 1217",
    d: "M258.679,219.56a2.531,2.531,0,0,1,.58,1.806,3.044,3.044,0,0,1-.312,1.438,2.084,2.084,0,0,1-.881.9,2.664,2.664,0,0,1-1.315.312,2.821,2.821,0,0,1-.758-.089,2.229,2.229,0,0,1-.613-.245l.424-.836a1.672,1.672,0,0,0,.925.245,1.349,1.349,0,0,0,.992-.368,1.561,1.561,0,0,0,.39-1.115,1.628,1.628,0,0,1-1.226.446,1.973,1.973,0,0,1-.858-.19,1.616,1.616,0,0,1-.613-.546,1.438,1.438,0,0,1-.223-.8,1.55,1.55,0,0,1,.925-1.438,2.141,2.141,0,0,1,.936-.2,2.107,2.107,0,0,1,1.628.68Zm-.925,1.483a.7.7,0,0,0,.234-.535.658.658,0,0,0-.234-.524.892.892,0,0,0-.624-.2.836.836,0,0,0-.591.189.725.725,0,0,0,0,1.115.858.858,0,0,0,.6.2.925.925,0,0,0,.613-.245Z",
    transform: "translate(29.293 25.144)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_321",
    "data-name": "Rectangle 321",
    width: 8.651,
    height: 1.092,
    transform: "translate(279.868 250.847)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_322",
    "data-name": "Rectangle 322",
    width: 121.1,
    height: 124.946,
    rx: 8.76,
    transform: "translate(176.75 143.582)",
    fill: "#455a64",
    stroke: "#455a64",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_323",
    "data-name": "Rectangle 323",
    width: 44.647,
    height: 1.382,
    transform: "translate(184.018 289.764)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_324",
    "data-name": "Rectangle 324",
    width: 27.101,
    height: 1.382,
    transform: "translate(184.018 294.19)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_224",
    "data-name": "Ellipse 224",
    cx: 34.157,
    cy: 34.157,
    r: 34.157,
    transform: "translate(199.893 168.464)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1218",
    "data-name": "Path 1218",
    d: "M228.813,173.681c.346.334-6.756,8.428-15.886,18.071l-4.894,5.128-.569.58-.591-.524c-7.369-6.544-12.519-11.471-12.263-11.761s5.853,4.114,13.377,10.49h-1.115l4.838-5.173C220.775,180.894,228.489,173.347,228.813,173.681Z",
    transform: "translate(22.338 19.955)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1219",
    "data-name": "Path 1219",
    d: "M301.36,103.22c-35.116,36.732-83.03,36.732-83.03,36.732V258.12c0,41.515,83.03,60.678,83.03,60.678S384.4,299.635,384.4,258.12V139.952S336.5,139.952,301.36,103.22Z",
    transform: "translate(25.062 11.868)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1220",
    "data-name": "Path 1220",
    d: "M302.634,85.85c-40.355,42.206-95.4,42.206-95.4,42.206V263.837c0,47.7,95.4,69.719,95.4,69.719s95.426-22.017,95.426-69.719V128.056S342.978,128.056,302.634,85.85Zm83.041,174.264c0,41.515-83.041,60.678-83.041,60.678s-83.03-19.163-83.03-60.678V141.946s47.936,0,83.03-36.732c35.138,36.732,83.041,36.732,83.041,36.732Z",
    transform: "translate(23.788 9.874)",
    fill: "#1e1869"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(243.392 115.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1221",
    "data-name": "Path 1221",
    d: "M301.36,103.22c-35.116,36.732-83.03,36.732-83.03,36.732v2.23s47.936-1.371,83.03-37.646C336.5,140.811,384.4,142.182,384.4,142.182v-2.23S336.5,139.952,301.36,103.22Z",
    transform: "translate(-218.33 -103.22)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1222",
    "data-name": "Path 1222",
    d: "M218.33,242.17v.747c0,41,83.03,59.931,83.03,59.931S218.33,283.685,218.33,242.17Z",
    transform: "translate(-218.33 -87.27)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1223",
    "data-name": "Path 1223",
    d: "M292.81,302.848s83.041-18.951,83.041-59.931v-.747C375.851,283.685,292.81,302.848,292.81,302.848Z",
    transform: "translate(-209.78 -87.27)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1224",
    "data-name": "Path 1224",
    d: "M309.555,173.734a2.408,2.408,0,0,1-2.832-.769h0s-4.526-5.741-11.438-6.488c-4.593-.5-9.342,1.271-14.113,5.262a2.419,2.419,0,0,1-3.1-3.712c5.842-4.883,11.828-7.023,17.837-6.354,8.985,1,14.492,8.06,14.693,8.361a2.4,2.4,0,0,1-.457,3.344A1.963,1.963,0,0,1,309.555,173.734Z",
    transform: "translate(31.827 18.564)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1225",
    "data-name": "Path 1225",
    d: "M319.38,167.265a2.408,2.408,0,0,1-2.742-.669c-.769-.881-19.074-21.616-42.362-2.23a2.419,2.419,0,0,1-3.088-3.712c26.945-22.485,48.872,2.531,49.051,2.787a2.419,2.419,0,0,1-.268,3.411,2.374,2.374,0,0,1-.591.413Z",
    transform: "translate(31.043 17.385)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1226",
    "data-name": "Path 1226",
    d: "M329.269,160.85a2.386,2.386,0,0,1-2.742-.669c-1.048-1.215-25.874-29.508-59.608-3.578a2.419,2.419,0,1,1-2.943-3.835c37.424-28.773,65.94,3.946,66.219,4.281a2.408,2.408,0,0,1-.268,3.4A2.129,2.129,0,0,1,329.269,160.85Z",
    transform: "translate(30.184 16.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1227",
    "data-name": "Path 1227",
    d: "M324.729,226.732H314.607v-20.98c0-8.773-8.439-15.908-18.818-15.908s-18.806,7.135-18.806,15.908v20.98H266.86v-20.98c0-14.359,12.976-26.041,28.929-26.041s28.985,11.683,28.985,26.041Z",
    transform: "translate(30.633 20.648)",
    fill: "#455a64",
    stroke: "#455a64",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1228",
    "data-name": "Path 1228",
    d: "M330.259,212.7H263.182c-5.195,0-4.337,3.032-4.337,3.032V234.55c2.82,39.609,37.9,40.9,37.9,40.9s35.06-1.293,37.9-40.9V215.732S335.454,212.7,330.259,212.7Z",
    transform: "translate(29.707 24.435)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1229",
    "data-name": "Path 1229",
    d: "M301.059,253.856l-4.794-16.309a7.235,7.235,0,1,0-5.362,0l-4.794,16.309Z",
    transform: "translate(32.843 25.685)",
    fill: "#455a64",
    stroke: "#455a64",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1230",
    "data-name": "Path 1230",
    d: "M91.12,1.351a12.508,12.508,0,0,1,9.81-.669,22,22,0,0,1,8.417,5.4c4.682,4.515,7.614,11.4,9.3,17.692-7.09,1.416-14.414-2.642-18-4.939-5.674-3.623-13.723-13.623-9.52-17.48",
    transform: "translate(10.325 0.017)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1231",
    "data-name": "Path 1231",
    d: "M127.343,24.883a10.68,10.68,0,0,1-5.942-8.918,14.158,14.158,0,0,1,3.79-10.29,5.986,5.986,0,0,1,4.459-2.386,4.571,4.571,0,0,1,3.712,2.765,9.3,9.3,0,0,1,.58,4.782c-.524,5.574-2.062,10.8-6.577,14.058",
    transform: "translate(13.934 0.397)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1232",
    "data-name": "Path 1232",
    d: "M138.257,41.573a7.581,7.581,0,0,1-.936-.959l-2.408-2.709a37.624,37.624,0,0,1-6.823-9.933,22.964,22.964,0,0,1-1.917-11.85,15.5,15.5,0,0,1,.87-3.567,8.161,8.161,0,0,1,.4-.914c.089-.212.156-.312.167-.3a24.526,24.526,0,0,0-1.115,4.816A23.644,23.644,0,0,0,128.5,27.783a40.534,40.534,0,0,0,6.689,9.9c.992,1.182,1.795,2.129,2.33,2.809A7.525,7.525,0,0,1,138.257,41.573Z",
    transform: "translate(14.469 1.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1233",
    "data-name": "Path 1233",
    d: "M97.13,7.55a2.842,2.842,0,0,1,.5.3l1.382.936c1.193.825,2.9,2.029,5.005,3.545,4.2,3.021,9.955,7.28,16.2,12.129s11.806,9.375,15.785,12.7c2,1.661,3.59,3.021,4.682,3.98l1.249,1.115a3.178,3.178,0,0,1,.412.4,2.475,2.475,0,0,1-.479-.334l-1.3-1.037-4.771-3.857c-4.024-3.255-9.61-7.725-15.841-12.575S107.988,15.7,103.83,12.589L98.9,8.932l-1.327-1a2.7,2.7,0,0,1-.446-.379Z",
    transform: "translate(11.15 0.886)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1234",
    "data-name": "Path 1234",
    d: "M127.1,31.8a25.049,25.049,0,0,0-22.842-.346c-1.795.914-3.69,2.441-3.534,4.459s2.3,3.222,4.225,3.79a21.348,21.348,0,0,0,22.485-7.469",
    transform: "translate(11.561 3.333)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1235",
    "data-name": "Path 1235",
    d: "M108.73,34.249a6.32,6.32,0,0,1,1.115-.613c.368-.178.814-.4,1.349-.613a16.77,16.77,0,0,1,1.839-.68,19.91,19.91,0,0,1,2.3-.624,22.3,22.3,0,0,1,2.687-.491,28.482,28.482,0,0,1,6.254,0,27.49,27.49,0,0,1,6.087,1.483,26.163,26.163,0,0,1,2.5,1.115,21.562,21.562,0,0,1,2.062,1.182,18.207,18.207,0,0,1,1.616,1.115,11.362,11.362,0,0,1,1.115.936,6.143,6.143,0,0,1,.914.87c-.078.089-1.382-1.115-3.835-2.642a19.733,19.733,0,0,0-2.074-1.115,24.636,24.636,0,0,0-2.475-1.059,28.2,28.2,0,0,0-5.986-1.427,28.985,28.985,0,0,0-6.143,0,25.1,25.1,0,0,0-2.664.435,20.181,20.181,0,0,0-2.23.569C110.369,33.491,108.775,34.338,108.73,34.249Z",
    transform: "translate(12.481 3.584)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1236",
    "data-name": "Path 1236",
    d: "M313.92,49.825a15.986,15.986,0,0,1,8.071,5.942,8.26,8.26,0,0,1,2.062,4.972c0,1.828-1.5,3.723-3.344,3.6a4.66,4.66,0,0,1-2.787-1.55c-1.9-1.828-3.7-4.169-6.31-4.459-1.494-.167-3.1.379-4.459-.29a3.344,3.344,0,0,1-1.572-3.768,5.752,5.752,0,0,1,2.62-3.344,6.51,6.51,0,0,1,5.719-1.1Z",
    transform: "translate(35.065 5.711)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1237",
    "data-name": "Path 1237",
    d: "M316.775,38.488c-.468,3.188,2.754,5.017,5.072,4.994s4.459-1.249,6.432-2.43c4.56-2.7,9.309-5.574,12.073-10.033a8.606,8.606,0,0,0,1.471-4.459,4.537,4.537,0,0,0-2.152-3.991c-1.639-.892-3.679-.379-5.429.29a37.435,37.435,0,0,0-13.656,9.1,13.054,13.054,0,0,0-3.813,6.588",
    transform: "translate(36.357 2.555)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1238",
    "data-name": "Path 1238",
    d: "M311.8,39.173a9.632,9.632,0,0,0,7.168-5.407,17.034,17.034,0,0,0,1.4-9.13,28.3,28.3,0,0,0-3.021-10.468,10.034,10.034,0,0,0-2.575-3.422,4.459,4.459,0,0,0-4.047-.87c-2.007.691-2.887,3-3.422,5.061A70.517,70.517,0,0,0,305.349,26c-.3,3-.368,6.165.936,8.918s3.523,4.626,5.953,4.236",
    transform: "translate(35.03 1.134)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1239",
    "data-name": "Path 1239",
    d: "M292.14,63.873a5.286,5.286,0,0,0,.959-.8l2.486-2.163a47.09,47.09,0,0,1,3.835-2.988A35.675,35.675,0,0,1,304.581,55a20.769,20.769,0,0,1,5.574-1.75,10.936,10.936,0,0,1,4.76.3,10.424,10.424,0,0,1,2.9,1.416,6.5,6.5,0,0,0,.992.7,6.009,6.009,0,0,0-.881-.847,9.1,9.1,0,0,0-2.91-1.605,10.847,10.847,0,0,0-4.916-.424,20.812,20.812,0,0,0-5.775,1.75,35,35,0,0,0-5.228,3,43.47,43.47,0,0,0-3.768,3.155c-1.037.936-1.839,1.728-2.386,2.285a5.574,5.574,0,0,0-.8.892Z",
    transform: "translate(33.535 6.066)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1240",
    "data-name": "Path 1240",
    d: "M293.84,64.838a2.421,2.421,0,0,0,.412-.39l1.115-1.115c.948-1,2.33-2.464,4.08-4.2,3.478-3.512,7.436-7.09,13.188-11.973,5.407-4.593,11.794-9.844,16.265-12.976,1-.713,1.929-1.349,2.742-1.884s1.516-1.026,2.107-1.393l1.293-.87a2.23,2.23,0,0,0,.446-.334,2.531,2.531,0,0,0-.491.245l-1.393.792c-.6.346-1.315.792-2.14,1.327s-1.784,1.115-2.8,1.839A180.033,180.033,0,0,0,313.3,45.641c-5.752,4.894-10.724,9.61-14.147,13.2-1.717,1.773-3.055,3.266-3.958,4.325-.424.491-.758.9-1.026,1.215a2.452,2.452,0,0,0-.334.457Z",
    transform: "translate(33.73 3.428)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1241",
    "data-name": "Path 1241",
    d: "M302,56.649a12,12,0,0,0,1.115-1.215c.691-.825,1.639-2.051,2.72-3.634a57.976,57.976,0,0,0,3.445-5.786,53,53,0,0,0,3.344-7.536,41.493,41.493,0,0,0,2.754-14.671,19.619,19.619,0,0,0-.167-2.586,6.321,6.321,0,0,0-.123-1.115c-.067-.379-.123-.6-.178-.881a10.132,10.132,0,0,0-.412-1.605,45.567,45.567,0,0,1,.535,6.131,43.576,43.576,0,0,1-2.876,14.492,61.688,61.688,0,0,1-3.277,7.491,66.116,66.116,0,0,1-3.344,5.808c-1.037,1.594-1.94,2.843-2.586,3.7A10.561,10.561,0,0,0,302,56.649Z",
    transform: "translate(34.667 2.042)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurePayment);
export default __webpack_public_path__ + "static/media/secure-payment.46bce5b46c90e2eb090c3b042a4e3888.svg";
export { ForwardRef as ReactComponent };